import Home from "../View/Home/index";
import BlogList from "../../Web/View/Blog/List";
import BlogSingle from "../../Web/View/Blog/Single";
import Card from "../../Web/View/Card";
import CoachList from "../../Web/View/Coach/List";
import CoachSingle from "../../Web/View/Coach/Single";
import MainDetailsSite from "../View/MainDetailsSite";
import RulesSite from "../View/RulesSite";
import Privacy from "../View/Privacy";
import ItemList from "../../Web/View/Item/List";
import ItemSingle from "./../View/Item/Single";
import ClassesList from "../View/Classes/Pages/List";
import ClassSingle from "../View/Classes/Pages/Single";
import ClassOrder from "../View/Classes/Pages/ClassOrder";
import Check from "../View/Auth/Check";
import UserLogin from "../View/Auth/UserLogin";
import AdminLogin from "../View/Auth/AdminLogin";
import Signup from "../View/Auth/Signup";
import VeryfyCode from "../View/Auth/VeryfyCode";
import ForgetPassword from "../View/Auth/ForgetPassword";
import Ticket from "../View/Ticket/Page";
import Tag from "../View/Tag/Tag";
import TimeTable from "../Common/TimeTable";
import ContractTrcaing from "../View/Contract/Pages/Tracking";
import FormContract from "../View/Contract/Pages/Form";
import MenuContract from "../View/Contract/Pages/Menu/index";
import Clup from "../View/Clup/index";
import Exite from "../View/Exite/Index";
import Weblog from "../View/Weblog/index";
import RoadMap from "../View/RoadMap/index";
import Questons from "../View/Questions/index";
import Reserve from "../View/Reserves/Pages";
import FAQ from "../View/faq/index";
import Redirect from "../View/Item/Redirect";
import Redirec2 from "../View/Item/Redirect2";
import React from "react";


const renderReservesPage = () => {
  let arr = [];
  [
    {
      city: "neyshabur",
    },
    {
      city: "tehran",
    },
    {
      city: "shahrood",
    },
    {
      city: "semnan",
    },
    {
      city: "mashhad",
    },
  ].map(element => {
    arr.push({
      path: "/" + element.city,
      name: "Reserve",
      exact: true,
      component: Reserve,
      label: "رزرو سالن",
      icon: null,
    });
  });
  return arr;
};
export const routes = [
  {
    path: "/",
    name: "Home",
    exact: true,
    component: Home,
    label: "صفحه اصلی",
    icon: null,
  },
  {
    path: "/exiteacount",
    name: "ExiteAcoounte",
    exact: true,
    component: Exite,
    label: "خروج از حساب",
    icon: null,
  },

  {
    path: "/adminnloginn",
    name: "AdminnLoginn",
    exact: true,
    component: AdminLogin,
    label: "ورود ادمین",
    icon: null,
  },
  {
    path: "/UserLogin",
    name: "UsesrLogin",
    exact: true,
    component: UserLogin,
    label: "ورود کاربر",
    icon: null,
  },
  {
    path: "/check",
    name: "check",
    exact: true,
    component: Check,
    label: "ورود کاربر",
    icon: null,
  },
  {
    path: "/SignUp",
    name: "SignUp",
    exact: true,
    component: Signup,
    label: "ثبت نام",
    icon: null,
  },
  {
    path: "/VeryfyCode",
    name: "VeryfyCode",
    exact: true,
    component: VeryfyCode,
    label: "کد تایید",
    icon: null,
  },
  {
    path: "/ForgetPassword",
    name: "ForgetPassword",
    exact: true,
    component: ForgetPassword,
    label: "کد تایید",
    icon: null,
  },
  {
    path: "/roadmap",
    name: "RoadMap",
    exact: true,
    component: RoadMap,
    label: "داستان نیکوتن",
    icon: null,
  },
  {
    path: "/faq",
    name: "Questions",
    exact: true,
    component: Questons,
    label: "سوالات متداول",
    icon: null,
  },
  {
    path: "/blogs",
    name: "blogs",
    exact: true,
    component: BlogList,
    label: "وبلاگ",
    icon: null,
  },
  {
    path: "/blogs/:slug",
    name: "Blog",
    exact: true,
    component: BlogSingle,
    label: "مقاله",
    icon: null,
  },
  {
    path: "/Classes/List",
    name: "ClassesList",
    exact: true,
    component: ClassesList,
    label: "کلاسها",
    icon: null,
  },

  {
    path: "/Classes/Single/:slug",
    name: "ClassSingle",
    exact: true,
    component: ClassSingle,
    label: "کلاس",
    icon: null,
    noMargin: true,
  },

  {
    path: "/Classes/ClassOrder/:slug",
    name: "ClassOrder",
    exact: true,
    component: ClassOrder,
    label: "پرداخت کلاس",
    icon: null,
  },
  {
    path: "/card",
    name: "Card",
    exact: true,
    component: Card,
    label: "سبد خرید",
    icon: null,
  },
  {
    path: "/faq",
    name: "FAQ",
    exact: true,
    component: FAQ,
    label: "صفحه اصلی",
    icon: null,
  },
  {
    path: "/Clup",
    name: "clup",
    exact: true,
    component: Clup,
    label: "باشگاه مشتریان",
    icon: null,
  },
  {
    path: "/pool/:city_slug",
    name: "Item",
    exact: true,
    component: ItemList,
    label: "مجموعه ها",
    icon: null,
  },
  {
    path: "/gym/:city_slug",
    name: "Item",
    exact: true,
    component: ItemList,
    label: "مجموعه ها",
    icon: null,
  },
  {
    path: "/salon/:city_slug",
    name: "Item",
    exact: true,
    component: ItemList,
    label: "مجموعه ها",
    icon: null,
  },

  {
    path: "/pool/:city_slug/:slug",
    name: "Item",
    exact: true,
    component: ItemSingle,
    label: "مجموعه",
    icon: null,
  },
  {
    path: "/gym/:city_slug/:slug",
    name: "Item",
    exact: true,
    component: ItemSingle,
    label: "مجموعه",
    icon: null,
  },
  {
    path: "/salon/:city_slug/:slug",
    name: "Item",
    exact: true,
    component: ItemSingle,
    label: "مجموعه",
    icon: null,
  },
  {
    path: "/MainDetailsSite",
    name: "MainDetailsSite",
    exact: true,
    component: MainDetailsSite,
    label: "اطلاعات سایت",
    icon: null,
  },
  {
    path: "/RulesSite",
    name: "RulesSite",
    exact: true,
    component: RulesSite,
    label: "قوانین سایت",
    icon: null,
  },
  {
    path: "/Privacy",
    name: "Privacy",
    exact: true,
    component: Privacy,
    label: "حریم خصوصی",
    icon: null,
  },
  {
    path: "/ticket",
    name: "ticket",
    exact: true,
    component: Ticket,
    label: "بلیت",
    icon: null,
  },
  {
    path: "/contract/tracking",
    name: "Contractregistore",
    exact: true,
    component: ContractTrcaing,
    label: "پیگیری قرارداد",
    icon: null,
  },
  {
    path: "/contract/new",
    name: "NewContract",
    exact: true,
    component: FormContract,
    label: "ثبت قرارداد",
    icon: null,
  },
  {
    path: "/site/contract",
    name: "MenuContract",
    exact: true,
    component: MenuContract,
    label: "ثبت یا پیگیری قراداد",
    icon: null,
  },
  {
    path: "/weblog",
    name: "Weblog",
    exact: true,
    component: Weblog,
    label: "بلیت",
    icon: null,
  },
  {
    path: "/pool",
    name: "Reserve",
    exact: true,
    component: Reserve,
    label: "رزرو استخر",
    icon: null,
  },
  {
    path: "/gym",
    name: "Reserve",
    exact: true,
    component: Reserve,
    label: "رزرو باشگاه",
    icon: null,
  },
  {
    path: "/salon",
    name: "Reserve",
    exact: true,
    component: Reserve,
    label: "رزرو سالن",
    icon: null,
  },
  {
    path: "/Items/:slug",
    exact: true,
    name: "Redirect",
    component: Redirect,
    label: "redirect",
  },
  {
    path: "/movjshahrood",
    exact: true,
    name: "Redirect",
    component: Redirec2,
    label: "redirect",
  },
  // ...renderReservesPage(),
];
